export const AMAZON_MARKETPLACES = {
  US: { 
    name: 'amazon.com', 
    domain: 'amazon.com', 
    
    currency: 'USD',
    language: 'English'
  },
  UK: { 
    name: 'amazon.co.uk', 
    domain: 'amazon.co.uk', 
    
    currency: 'GBP',
    language: 'English'
  },
  CA: { 
    name: 'amazon.ca', 
    domain: 'amazon.ca', 
    
    currency: 'CAD',
    language: 'English/French'
  },
  DE: { 
    name: 'amazon.de', 
    domain: 'amazon.de', 
    
    currency: 'EUR',
    language: 'German'
  },
  FR: { 
    name: 'amazon.fr', 
    domain: 'amazon.fr', 
    flag: '🇫🇷',
    currency: 'EUR',
    language: 'French'
  },
  ES: { 
    name: 'amazon.es', 
    domain: 'amazon.es', 
    //flag: '🇪🇸',
    currency: 'EUR',
    language: 'Spanish'
  },
  IT: { 
    name: 'amazon.it', 
    domain: 'amazon.it', 
    //flag: '🇮🇹',
    currency: 'EUR',
    language: 'Italian'
  },
  JP: { 
    name: 'amazon.co.jp', 
    domain: 'amazon.co.jp', 
    //flag: '🇯🇵',
    currency: 'JPY',
    language: 'Japanese'
  },
  IN: { 
    name: 'amazon.in', 
    domain: 'amazon.in', 
   // flag: '🇮🇳',
    currency: 'INR',
    language: 'English/Hindi'
  },
  AU: { 
    name: 'amazon.com.au', 
    domain: 'amazon.com.au', 
    //flag: '🇦🇺',
    currency: 'AUD',
    language: 'English'
  },
  BR: { 
    name: 'amazon.com.br', 
    domain: 'amazon.com.br', 
    //flag: '🇧🇷',
    currency: 'BRL',
    language: 'Portuguese'
  },
  MX: { 
    name: 'amazon.com.mx', 
    domain: 'amazon.com.mx', 
    //flag: '🇲🇽',
    currency: 'MXN',
    language: 'Spanish'
  },
  NL: { 
    name: 'amazon.nl', 
    domain: 'amazon.nl', 
    //flag: '🇳🇱',
    currency: 'EUR',
    language: 'Dutch'
  },
  SG: { 
    name: 'amazon.sg', 
    domain: 'amazon.sg', 
    //flag: '🇸🇬',
    currency: 'SGD',
    language: 'English'
  },
  AE: { 
    name: 'amazon.ae', 
    domain: 'amazon.ae', 
    //flag: '🇦🇪',
    currency: 'AED',
    language: 'English/Arabic'
  }
};